export default __webpack_public_path__ + "static/media/wheelbarrow.f8e5ff2c.svg";